import { format } from '@sravni/utils/lib/money';

const getZarplatnyjProektTerms = item => {
    // “Комиссия за начисление з/п” и “Обслуживание счета”
    const conditions = [];
    const { rko, commission } = item;
    const commissionValue = commission || commission === 0 ? `${commission} %` : 'Бесплатно';
    conditions.push({ value: commissionValue, description: 'Комиссия за начисление з/п', wide: true, key: 'commission' });
    const accountMaintenanceValue = `от ${format(rko)} ₽ в месяц`;
    conditions.push({
        value: accountMaintenanceValue,
        description: 'Обслуживание счета',
        wide: true,
        key: 'accountMaintenance',
    });
    return conditions;
};

export { getZarplatnyjProektTerms };
//# sourceMappingURL=zarplatnyjProekt.js.map
